<template>
  <Modal
    :modelValue="open"
    class="ProgressModalContainer"
    persistent
  >
    <StepProgressBar
      class="ProgressModal"
      :step="step"
      :steps="steps"
    />
  </Modal>
</template>

<script setup lang="ts">
import StepProgressBar from '../../atoms/StepProgressBar/StepProgressBar.vue';
import Modal from '../../molecules/Modal/Modal.vue';
import type { StepProgressBarProps } from '../../atoms/StepProgressBar/StepProgressBar.model';

interface ProgressModalProps extends StepProgressBarProps {
  open?: boolean;
}

defineProps<ProgressModalProps>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/responsive';

@layer cvo-ui {
  .ProgressModalContainer {
    width: auto;
    max-width: 450px;
    background-color: vars.$molecules-loader-bg-color;
    z-index: vars.$z-index-loader;
  }

  .ProgressModal {
    width: 200px;
    margin: 0 auto;

    .StepProgressBar-header {
      min-height: 4em;
    }
  }
}
</style>
